import { forwardRef, type Ref, type SVGProps } from "react";
const IconZillowMarkSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M21.549 9.663a.96.96 0 0 0-.982-.368c-2.123.479-9.93 2.59-17.658 6.306v-3.508c0-.568.26-1.104.705-1.457 3.197-2.525 11.13-8.782 11.13-8.782a1.86 1.86 0 0 1 2.306 0l10.881 8.599.23.183c.444.353.703.895.703 1.459l-.003-.004V16.4c-3.454.478-10.626 2.183-13.745 3.339-.028.01-.06.003-.018-.044 1.753-2.009 4.802-4.76 7.615-6.828a.956.956 0 0 0 .206-1.34z" />
    <path d="M9.12 25.7a.95.95 0 0 0 1.098.264v.003c4.972-2.084 14.858-4.533 18.645-5.068v6.7a1.86 1.86 0 0 1-1.86 1.855H4.77c-1.03 0-1.86-.83-1.86-1.857v-8.305c2.828-1.386 10.197-4.117 12.74-4.803.05-.013.062.017.017.047-2.074 1.379-6.585 6.26-8.094 8.003a.96.96 0 0 0-.025 1.226c.45.562 1.118 1.396 1.572 1.934Z" />
  </svg>
);
const ForwardRef = forwardRef(IconZillowMarkSVG);
ForwardRef.displayName = "IconZillowMark";
export { ForwardRef as IconZillowMark };
